module.exports = __webpack_public_path__ + "yeni gürsu özcan bey.jpg?1f3d64a94b2da7a16cf2100f2c5438a1";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni gürsu özcan bey.jpg
// module id = 384
// module chunks = 0